// extracted by mini-css-extract-plugin
export default {"sectionTitle":"shippingAddress_sectionTitle__sJQ7K","buttonLabel":"shippingAddress_buttonLabel__weuGc","componentContainer":"shippingAddress_componentContainer__TJ7Kx"};